export default __webpack_public_path__ + "static/media/button.8073e571.less";